var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-leave": function ($event) {
        return _vm.$emit('destroy');
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toastVisible,
      expression: "toastVisible"
    }],
    staticClass: "message",
    class: [_vm.handleStyle(_vm.type), _vm.isH5 && 'message-h5'],
    style: _vm.customStyle
  }, [!_vm.isH5 ? _c('p', [_vm._v(" " + _vm._s(_vm.message) + " ")]) : _vm._e(), _vm.isH5 ? _c('span', [_vm._v(_vm._s(_vm.message))]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }